// import { auth } from '../helpers/firebase.module';

export const reducer = (state) => {
  return {
    //Only curry functions:::::
    login: (user) => {
      const userDataHasura = user?.userDataHasura;
      const userData = {
        ...user?.userDataHasura,
        ...user?.userAccount,
      };
      return {
        user: userData,
        isAuth: true,
        userWorks: userDataHasura?.works,
        userVolunteers: userDataHasura?.volunteers,
        userSchools: userDataHasura?.schools,
        userResearchs: userDataHasura?.researchs,
        userLetters: userDataHasura?.letters,
      };
    },
    logout: () => {
      // auth.signOut();
      return {
        user: {},
        isAuth: false,
      };
    },
    setUser: (data) => ({ user: data }),
    changeShowMenu: (data) => {
      console.log("dispatchchange menu", data);
      return { showMenu: data };
    },
    setUserWorwks: (data) => ({ userWorks: data }),
    setUserVolunteers: (data) => ({ userVolunteers: data }),
    setUserSchools: (data) => ({ userSchools: data }),
    setUserResearchs: (data) => ({ userResearchs: data }),
    setUserLetters: (data) => ({ userLetters: data }),
    setChatModal:(data) => ({ showChatModal: data }),
    set: (key, value) => ({ [key]: value }),
  };
};

export const initialState = () => {
  return {
    isAuth: false,
    user: {},
    showMenu: false,
    userWorks: [],
    userVolunteers: [],
    userSchools: [],
    userResearchs: [],
    userLetters: [],
    showChatModal:false
  };
};
